import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-file-download-dialog',
  templateUrl: './file-download-dialog.component.html',
  styleUrls: ['./file-download-dialog.component.css']
})
export class FileDownloadDialogComponent {
  remotePath: string = '';

  constructor(
    public dialogRef: MatDialogRef<FileDownloadDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    // Pre-fill with last used remote path from localStorage
    const lastRemotePath = localStorage.getItem('lastRemoteDownloadPath');
    if (data && data.remotePath) {
      this.remotePath = data.remotePath;
    } else if (lastRemotePath) {
      this.remotePath = lastRemotePath;
    }
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onDownload(): void {
    if (this.remotePath) {
      // Save to localStorage
      localStorage.setItem('lastRemoteDownloadPath', this.remotePath);
      this.dialogRef.close({ remotePath: this.remotePath });
    }
  }
}
